import { AnyAction } from 'redux';


import { RequestStatus } from 'common/enums/request-status';
import { AdminState } from 'unit-admin/interfaces/redux-state';
import { AdminCompaniesState } from 'unit-admin/pages/companies/interfaces/redux-state';
import { adminCompaniesReducerMethods } from '../units/admin/reducers/companies';

export const INITIAL_COMPANIES_STATE: AdminCompaniesState = {
  count: 0,
  data: [],
  status: RequestStatus.Loaded,
  statuses: {
    deletedProjects: RequestStatus.Loaded,
    attachDatabases: RequestStatus.Loaded,
    detachDatabase: RequestStatus.Loaded,
    attachEmployee: RequestStatus.Loaded,
    detachEmployee: RequestStatus.Loaded,
    loadCompanyRoles: RequestStatus.Loaded,
    changeRole: RequestStatus.Loaded,
    loadProjectsEmployee: RequestStatus.Loaded,
    attachEmployeeToProject: RequestStatus.Loaded,
    detachEmployeeFromProject: RequestStatus.Loaded,
    getSubscriptionPlans: RequestStatus.NotRequested,
    setMockSubscription: {},
    resetMockSubscription: {},
    createEmptySubscription: {},
    currencies: RequestStatus.NotRequested,
    updateCurrency: {},
  },
  databaseFeed: {
    count: 0,
    data: [],
    status: RequestStatus.Loaded,
  },
  employeeFeed: {
    count: 0,
    data: [],
    status: RequestStatus.Loaded,
  },
  selectedCompanyRoles: [],
  selectedProjectEmployees: [],
  subscriptionPlanOptions: [],
  currencies: [],
};


function adminCompanies(
  state: AdminCompaniesState = INITIAL_COMPANIES_STATE,
  action: AnyAction = { type: '', payload: null },
): AdminCompaniesState {
  if (action.type in adminCompaniesReducerMethods) {
    return adminCompaniesReducerMethods[action.type](state, action.payload);
  } else {
    return state;
  }
}

const INITIAL_STATE: AdminState = {
  companies: INITIAL_COMPANIES_STATE,
};

export default function admin(
  state: AdminState = INITIAL_STATE,
  action: AnyAction = { type: '', payload: null },
): AdminState {
  if (action.type in adminCompaniesReducerMethods) {
    return { ...state, companies: adminCompanies(state.companies, action) };
  } else  {
    return state;
  }
}

